<!-- <div class="preloader" [hidden]="load">
  <div class="loading">
      <img src="assets/images/loader/loader.svg" alt="">
  </div>
</div> -->

<app-loading [hidden]="load"></app-loading>

<section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="background-size: cover; background-position: center center;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h1 class="pagetitle__heading mb-10">Publications</h1>
                <!--<nav>
                <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item"><a routerLink="/home">home</a></li>
                    <li aria-current="page" class="breadcrumb-item active">Research-Team</li>
                </ol>
            </nav>-->
            </div>
        </div>
    </div>
</section>

<section class="portfolio-layout3">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-3">
                <ul class="portfolio-filter  justify-content-center list-unstyled" style="padding: 11px;">
                    <li [ngClass]="{'active2': selectedItem == null}" ><a routerLink="/publications" (click)="getTitle()">All Publications</a></li>
                    <li *ngFor="let item of arrayPublicationCategroy" [ngClass]="{'active2': selectedItem == item.postID}">
                      <a style="cursor: pointer;" routerLink="/publications/{{item.postID}}/{{item.postTitle}}" (click)="getPublications()">{{item.postTitle}}</a>
                    </li>
                </ul>
            </div>

            <div class="row col-sm-12 col-md-12 col-lg-9" style="min-height: 400px;">
                <div [hidden]="ShowTitle"  class="col-sm-12 col-md-12 col-lg-12">
                    <h4 class="job-item__title job-item__type"  style="  font-size: 13px;
                    text-transform: capitalize;
                    background-color: #019cce;
                    color: #fff;
                    padding: 5px 8px;
                    margin-bottom: 15px !important;text-align: center;border-radius: 0px 0 40px 40px !important;">{{Title}}
                    </h4> </div>
                <ng-container   *ngFor="let a of array2">
                    <div [hidden]="!ShowTitle"  class="col-sm-12 col-md-12 col-lg-12">
                        <h4 class="job-item__title job-item__type"  style="  font-size: 13px;
                        text-transform: capitalize;
                        background-color: #019cce;
                        color: #fff;
                        padding: 5px 8px;
                        margin-bottom: 15px !important;text-align: center;border-radius: 0px 0 40px 40px !important;">{{a.Title}}
                        </h4> </div>
                <div class="col-sm-12 col-md-12 col-lg-12" *ngFor="let item of a.ourPublication">
                    <div class="job-item">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <h4  class="job-item__title job-item__type">{{item.postTitle}}</h4>
                                <p>{{item.postSubTitle}}</p>
                                <p class="pDetails"  [innerHTML]="item.postDetails"></p>
                       </div>
                        </div>
                    </div>
                </div>
</ng-container>
            </div>
        </div>
    </div>
</section>
